import { render } from "./SidebarMenu2.vue?vue&type=template&id=06ec4b28&scoped=true"
import script from "./SidebarMenu2.vue?vue&type=script&lang=js"
export * from "./SidebarMenu2.vue?vue&type=script&lang=js"

import "./SidebarMenu2.vue?vue&type=style&index=0&id=06ec4b28&lang=scss&scoped=true"

import exportComponent from "../../../../../SINTEZ/OKCU/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ec4b28"]])

export default __exports__